import Block from '../block'

export default class NavPopup extends Block {
	static title = 'nav-popup'

	constructor($el) {
		super($el)

		// open side menu
		this.$el.findElement('toggle').on('click', () => {
			if (this.isOpen()) {
				this.close()
			} else {
				this.open()
			}
		})

		this.$el.findElement('popup-close').on('click', () => this.close())

		this.$el.findElement('popup-overlay').on('click', () => this.close())

		$(document).on('keydown', (e) => {
			if (e.key === 'Escape' && this.isOpen()) {
				this.close()
			}
		})

		$(document).on('product:add', (index, data) => {
			this.$el.findElement('count--span').text(data.count)
		})

		$(document).on('product:remove', (index, data) => {
			this.$el.findElement('count--span').text(data.count)
		})

		$(document).on('product:update', (index, data) => {
			this.$el.findElement('count--span').text(data.count)
		})
	}

	isOpen() {
		const $popup = this.$el.findElement('popup')

		return (
			!$popup.hasClass('hidden') &&
			!$popup.hasClass('nav-popup__popup--closing')
		)
	}

	open() {
		this.closing = null
		this.$el.addClass('nav-popup--active')
		this.$el.findElement('close').removeClass('hidden')
		this.$el
			.findElement('popup')
			.removeClass('hidden nav-popup__popup--closing')
		this.syncState()
	}

	// the closing modifier runs the theme's exit animations; the popup only hides once they finish
	async close() {
		const $popup = this.$el.findElement('popup')
		const token = (this.closing = {})

		this.$el.findElement('close').addClass('hidden')
		$popup.addClass('nav-popup__popup--closing')
		this.syncState()

		const running = $popup
			.get(0)
			.getAnimations({ subtree: true })
			.filter((a) => a.effect?.getComputedTiming().endTime !== Infinity)

		await Promise.allSettled(running.map((a) => a.finished))

		// reopened mid-exit
		if (this.closing !== token) return

		this.closing = null
		$popup.addClass('hidden').removeClass('nav-popup__popup--closing')
		this.$el.removeClass('nav-popup--active')
	}

	// keyboard users land on the close button when the menu opens and back on the toggle when it shuts
	syncState() {
		const open = this.isOpen()

		this.$el
			.findElement('toggle')
			.attr('aria-expanded', open ? 'true' : 'false')

		if (open) {
			this.$el.findElement('popup-close').get(0)?.focus()
		} else if (
			this.$el.find(':focus').length ||
			document.activeElement === document.body
		) {
			this.$el.findElement('toggle').get(0)?.focus()
		}
	}
}
